const getStyles = (options) =>
  `.label {
      font-family: ${options.fontFamily};
    }`;

export default getStyles;
